export default "__VITE_ASSET__D9Muydj9__"